<template>
    <div class="card float-e-margins">
        <div class="card-title">
            <h1>Verzenden en ophalen</h1>
        </div>
        <div class="card-content">
            <div class="row">
                <div class="col-md-12">
                    <p>
                        <strong>Verzenden</strong> :
                    </p>
                    <p>
                        Nadat we je betaling ontvangen hebben zullen we je bestelling binnen 5 werkdagen verzenden , soms kunnen we het de volgende (werk)dag al verzenden.
                    </p>
                    <p>
                        <strong>Verzendkosten:</strong>
                    </p>
                    <p>
                        Wij versturen de artikelen via PostNL tegen de actuele geldende tarieven, kijk voor de verzendkosten en voorwaarden op <a href="http://www.postnlpakketten.nl/">http://www.postnlpakketten.nl/</a> . Wil je je bestelling aangetekend of verzekerd verzonden hebben , geef dat dan aan bij je bestelling , want hiervoor gelden andere tarieven.
                    </p>
                    <p v-for="rate in shippingRates.shipping_rates" :key="rate.price">
                        <span v-if="rate.type === 'Brievenbuspakketje'">
                        Kan je aankoop door de brievenbus , dan zal dat met track &amp; trace code verzonden worden, dit kost dan {{ rate.price | currencyDisplay }}.
                        </span>
                        <span v-else>
                        {{ rate.type }} : {{ rate.description }}. {{ rate.price | currencyDisplay }}: maximale afmetingen {{ rate.dimensions }}.
                        </span>
                    </p>
                    <p> Wij verzenden ook naar het buitenland, heb je hierover een vraag , stuur dan een e-mail voor de tarieven van de verzendkosten. </p>
                    <p>
                        Gratis verzending (Standaard 0 - 10 kg) vanaf {{ shippingRates.special_rate.price | currencyDisplay }}! Dit geldt alleen binnen Nederland.
                    </p>
                    <p>
                        Je bestelling wordt pas verzonden als het hele bedrag inclusief verzendkosten is voldaan.
                    </p>
                    <p>
                    <strong>
                    Wij verzenden wereldwijd - We offer global shipping
                    </strong>
                    </p>
                    <p>
                        <strong>Verpakken / verzenden:</strong>
                    </p>
                    <p>
                        Zodra de betaling ontvangen is gaan wij het bestelde artikel verzendklaar maken, wij zullen elk artikel zeer goed verpakken zodat dit veilig verstuurd kan worden. Wij kunnen niet aansprakelijk gesteld worden als er tijdens de verzending breuk en / of transportschade optreedt , ook niet als deze veroorzaakt wordt door PostNL, zodra het artikel verzonden is stuur ik je per e-mail de (eventuele) track&amp;trace code zodat je het pakket online kunt volgen. Wij bewaren zelf ook het track&amp;trace bewijs zodat wij weten waar de zending zich bevindt.
                    </p>
                    <p>
                        Wij zullen de bestelling binnen 5 werkdagen verzenden. Dit kan ook eerder plaats vinden.
                    </p>
                    <p>
                        We zouden het leuk vinden als je na ontvangst van het artikel ons een berichtje stuurt via e-mail of een berichtje plaatst in het gastenboek wat je van het artikel vindt.
                    </p>
                    <p>
                        <strong>Retour zenden:</strong>
                    </p>
                        <p>Als een artikel niet is zoals je verwacht had mag je het altijd terug sturen. <br> Wij storten het hele aankoopbedrag terug inclusief verzendkosten. Laat wel even weten waarom je het retour stuurt doe dit wel binnen 14 dagen. <br> Is het artikel in de zelfde staat door ons ontvangen zoals wij het naar jou verstuurt hebben zullen we het aankoopbedrag inclusief verzendkosten terug storten.  <br> Om het artikel retour te zenden vragen we je het via Post NL te versturen en het track &amp; trace nummer te bewaren.</p>
                        <p>Het retour zenden is voor eigen rekening.</p>
                    <p>
                        <strong>Ophalen:</strong>
                    </p>
                    <p>
                        Artikelen kunnen soms te groot of te kwetsbaar zijn om te versturen, dan kun je deze na overleg op komen halen. Als dat van toepassing is kun je met ons <a v-link="{ path: '/klantenservice/contact'}">contact</a> opnemen.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import shippingRatesData from '../../assets/shippingRates.json'

export default {
  data () {
    return {
      shippingRates: shippingRatesData
    }
  }
}
</script>


// WEBPACK FOOTER //
// shipping.vue?6b98e3be